'use es6';

import accumulate from './accumulate';
import aggregate from './aggregate';
import { TransformTypes } from './transformRecords';
export const applyTransformations = (originalDataset, transformations) => {
  if (!transformations || !originalDataset) {
    return originalDataset;
  }
  const result = transformations.reduce((dataset, transformation) => {
    switch (transformation.get('type')) {
      case TransformTypes.AGGREGATE:
        return aggregate(dataset, {
          groupby: transformation.get('groupBy'),
          aggregate: transformation.get('aggregations').toJS()
        });
      case TransformTypes.ACCUMULATE:
        return accumulate(dataset, transformation.toJS());
      default:
        return dataset;
    }
  }, originalDataset);
  return result;
};